import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { GamesImagesStyles } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const GAMES_IMAGES_ASSETS_URL: DiToken<string> = new DiToken<string>('gamesImagesAssetsUrl', {
  factory: () => 'https://storage.googleapis.com/januszcasino-prod-static-assets/images/'
});

// eslint-disable-next-line @typescript-eslint/naming-convention
export const GAMES_IMAGES_STYLE: DiToken<GamesImagesStyles> = new DiToken<GamesImagesStyles>('gamesImagesStyle', {
  factory: () => 'energy'
});
